export default __webpack_public_path__ + "static/media/bateonBox.23bf92f5.svg";